<template>
  <div>
    <!-- loading page indicator -->
    <template v-if="isLoadingPage">
      <pre-loader />
    </template>

    <!-- page data -->
    <template v-if="!isLoadingPage">
      <section>
        <div class="section--title">
          <h1>Unprocessed Pre Service Bills</h1>
          <hr />
        </div>
      </section>

      <section class="mt-5">
        <FilterTable
          :from-date="queryStrings.from_date"
          :to-date="queryStrings.to_date"
          :searchStr="queryStrings.search_str"
          v-on:update:fromDate="queryStrings.from_date = $event"
          v-on:update:toDate="queryStrings.to_date = $event"
          v-on:update:searchStr="queryStrings.search_str = $event"
          @flterTable="updatePreServiceBills(queryStrings, 'filter')"
        />
      </section>

      <section class="mt-5">
        <div class="row">
          <div class="card border-0">
            <div class="card-body">
              <div class="d-flex border-bottom mb-4 px-2 align-items-center">
                <div class="w-100">
                  <p class="text--secondary font-weight-bold mb-3">
                    Showing result for record date from {{ queryStrings.from_date |  formatDate}} to
                    <span v-if="queryStrings.to_date">
                      {{ queryStrings.to_date |  formatDate}}
                    </span>
                    <span v-else>
                      {{ new Date() |  formatDate}}
                    </span>
                  </p>
                </div>

                <export-actions
                  :table-data="preServiceBillsData"
                  filename="preserviceBills.xls"
                  :json-fields="jsonFields"
                  @generatePDF="generatePDF"
                >
                  <button
                    class="ml-2 btn btn-sm btn-light" v-simple-print="'preserviceBillsTable'"
                  >Print</button>
                </export-actions>
              </div>
              <pre-service-bills-table :table-data="preServiceBillsData" />
              <el-pagination
                background
                layout="prev, pager, next"
                :total="paginationData.total"
                :current-page.sync="paginationData.page"
                :page-size.sync="paginationData.limit"
                :hide-on-single-page="true"
                :pager-count="5"
                @current-change="clickCallback"
                @prev-click="prevPage"
                @next-click="nextPage"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- export as pdf -->
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="preservicebills"
          :pdf-quality="2"
          :manual-pagination="false"
          :pdf-content-width="'100%'"
          pdf-format="a4"
          pdf-orientation="landscape"
          ref="html2Pdf"
        >
          <div slot="pdf-content">
            <pre-service-bills-table :table-data="preServiceBillsData" />
          </div>
        </vue-html2pdf>
      </section>
    </template>
  </div>
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import PreServiceBillsTable from '@/components/tables/flowTables/PreServiceBillsTable'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  components: {
    FilterTable,
    PreServiceBillsTable,
    VueHtml2pdf
  },
  data() {
    return {
      preServiceBillsData : [],
      isLoadingPage: true,
      paginationData: {},
      queryStrings: {
        from_date: '1970-01-01',
        per_page: 30,
        processed: 0,
        page: 1,
        search_str: '',
      }
    }
  },
   methods: {
    serializeQs(qs) {
      Object.keys(qs).forEach(elem => {
        if(qs[elem]===null || qs[elem]==='') {
          delete qs[elem];
        }
      });
    },
    async getPreServiceBillsData(qs, showLoadingIndicator) {
      if(showLoadingIndicator) {
        this.isLoadingPage = true
      }
      try {
        this.serializeQs(qs)
        const { data } = await this.$repos.preServiceBillsRepo.getPreServiceBillsData(qs);
        this.preServiceBillsData = data.data
        const paginationData = {
          total: data.total,
          currentPage: this.queryStrings.page,
          limit: this.queryStrings.per_page,
          page: this.queryStrings.page
        }
        this.paginationData = {...paginationData}
      }catch(error) {
        console.log(error)
      }finally {
        this.isLoadingPage = false
      }
    },
    clickCallback(page) {
      this.updatePreServiceBills({page})
    },
    prevPage() {
      const page = this.paginationData.page
      this.updatePreServiceBills({page: page - 1})
    },
    nextPage() {
      const page = this.paginationData.page
      this.updatePreServiceBills({page: page - 1})
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    updatePreServiceBills(qsObj, type) {
      const qsKey = Object.keys(qsObj)[0]
      const qsValue = Object.values(qsObj)[0]
      this.queryStrings[qsKey] = qsValue
       if(type === 'filter') {
        this.queryStrings.page = 1
      }
      const qs = this.queryStrings
      this.getPreServiceBillsData(qs, false)
    }
  },
  computed: {
    jsonFields() {
      return {
        Processed: "processed",
        "Payment Log Id": "payment_log_id",
        "Tax Payer Name": "taxpayer_name",
        "Tax PAyer RIN": "taxpayer_rin",
        "Amount": "amount",
        "Service Bill Ref": "service_bill_ref",
        "MDA Service Ref": "mda_service_ref",
        "Tax Year": "tax_year"
      }
    }
  },
  async mounted() {
    await this.getPreServiceBillsData(this.queryStrings, true)
  },
}
</script>